module.exports = __webpack_public_path__ + "static/media/backdrop.35476420.jpg";